// Vendor imports
const { connect } = require('react-redux')
// Client V2 common imports
const { createQueryParamsSelector } = require('client-v2/common/state/router/selectors')

function ErrorTester(props) {
  if (props.message) {
    const err = new Error(props.message)
    if (props.name) {
      err.name = props.name
    }
    throw err
  }
  return null
}

function mapStateToProps() {
  const queryParamsSelector = createQueryParamsSelector()
  return function (state) {
    const queryParams = queryParamsSelector(state)
    return {
      message: queryParams['force_error_message'],
      name: queryParams['force_error_name']
    }
  }
}

module.exports = connect(
  mapStateToProps
)(
  ErrorTester
)
